import cx from 'clsx';
import { DocumentTextIcon, UploadIcon } from '@heroicons/react/outline';
import { Icon } from '@vechaiui/react';
import { useLocalization } from '@fluent/react';
import { useRef } from 'react';

import CompoundButton from './CompoundButton';

const FileCompoundButton: React.FC<FileCompoundButtonProps> = ({ className, ...props }) => {
  const { l10n } = useLocalization();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div>
      <CompoundButton
        className={cx('w-72 cursor-pointer', className)}
        leftIcon={
          <Icon
            as={DocumentTextIcon}
            label="document"
            className="w-6 aspect-square"
            color="black"
          />
        }
        onClick={handleClick}
        rightIcon={
          <Icon as={UploadIcon} label="upload" className="w-6 aspect-square" color="blue" />
        }
        secondaryText={`${l10n.getString('upload')} ${l10n.getString('delivery-order')}`}
      >
        {l10n.getString('delivery-order')}
        <input className="hidden" type="file" ref={fileInputRef} {...props} />
      </CompoundButton>
    </div>
  );
};
export type FileCompoundButtonProps = React.InputHTMLAttributes<HTMLInputElement>;

export default FileCompoundButton;
